import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { PaginationOptions } from 'src/app/core/models/pagination_options';

@Component({
  selector: 'app-custom-search-widget',
  templateUrl: './custom-search-widget.component.html',
  styleUrls: ['./custom-search-widget.component.scss'],
})
export class CustomSearchWidgetComponent {
  @Input()
  paginationOptions!: PaginationOptions;

  @Input()
  searchFields!: Array<string>;

  @Output()
  onSearch = new EventEmitter();

  public selectedSearchField!: CustomSelectOption;

  ngOnInit() {
    this.selectedSearchField = {
      name: this.formartName(this.searchFields[0]),
      value: this.searchFields[0],
    };
    this.onSearchFieldChanged();
  }

  onSearchFieldChanged() {
    this.paginationOptions.setSearchField(
      this.selectedSearchField?.value ?? this.getSearchFields()[0].value
    );
  }

  getSearchFields() {
    return this.searchFields.map((el) => {
      return { name: this.formartName(el), value: el };
    });
  }

  formartName(col: string): string {
    return col
      .replace(/_/gi, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  search() {
    this.onSearch.emit();
  }
}
